/*
  Scroll reveal for the recycling info section, same look as the theme's section animations.
  Each heading / card is observed on its own so long product grids reveal row by row
  instead of animating off screen, and items entering together are staggered.
*/
class RecyclingInfo extends HTMLElement {
  connectedCallback() {
    const html = document.documentElement;
    if (!this.classList.contains('animation') || !html.classList.contains('do-anim')) return;

    const items = this.querySelectorAll('.recycling-info__text, .product-item--recycling');
    if (!items.length) return;

    this.observer = new IntersectionObserver((entries) => {
      let delay = 0;
      entries.forEach((entry) => {
        if (!entry.isIntersecting) return;
        entry.target.style.setProperty('--delay-offset-multiplier', delay++);
        entry.target.classList.add('is-visible');
        this.observer.unobserve(entry.target);
      });
    }, { threshold: 0.15 });

    items.forEach((item) => this.observer.observe(item));
  }

  disconnectedCallback() {
    this.observer?.disconnect();
  }
}

if (!customElements.get('recycling-info')) {
  customElements.define('recycling-info', RecyclingInfo);
}
